require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-early-congressional-authorization-of-a-general-capital.json") })
        }
      }, "path---en-us-update-early-congressional-authorization-of-a-general-capital");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-early-congressional-authorization-of-a-general-capital!./.cache/json/en-us-update-early-congressional-authorization-of-a-general-capital.json
// module id = 661
// module chunks = 231608221292675